export default __webpack_public_path__ + "static/thesisImage-e7173997c0ea2f145b3818e77fb5b251.png";